module.exports = __webpack_public_path__ + "static/media/steps_icon2.6319d1d2.svg";